import { DataService } from './../../../Services/DataSharingService';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-contentNav',
	templateUrl: './contentNav.component.html',
	styleUrls: ['./contentNav.component.scss'],
	encapsulation: ViewEncapsulation.None
})

export class ContentNavComponent implements OnInit {

	public showCode = false;
	public data : any;
	public copyClipboard = false;
	@Input() parentCompName = '';
	currentComponent = '';

	@Output() onClick : EventEmitter<any> = new EventEmitter();
	constructor(private _dataService: DataService) {

		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(data => {
			this.currentComponent = data;
		})
		_dataService.copyToClipboardText.subscribe(value => {
			this.copyClipboard = value;
		});

	}
	@Input('headingText') headingText = '';
	ngOnInit() {
	}

	ShowCode() {
		this.showCode = !this.showCode
		this.onClick.emit({showCode: this.showCode});
	}
}


// WEBPACK FOOTER //
// ./src/app/features/contentNav/contentNav.component.ts